<span class="col-w s1">
    {{currentStep}}/{{totalSteps}}
</span>
<div class="_grid"
     [grid]="totalSteps"
     [gridColumnGap]="'8px'"
     [gridRowGap]="'0px'">
    @for(step of steps; track $index){
    <span class="block _indicator"
          [ngClass]="$index <= currentStep-1 ? 'bg-col-w' : 'bg-col-11'"></span>
    })
</div>